import manager from '@mailobj-browser/front/js/contracts/manager.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import once from '@mailobj-browser/front/js/events/options/once.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import defaults from '@mailobj-browser/front/js/selectors/defaults.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import append from '@mailobj-browser/front/js/tree/append.js'
import remove from '@mailobj-browser/front/js/tree/remove.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'
import replaceChildren from '@mailobj-browser/front/js/tree/replaceChildren.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import resolvable from '@mailobj-browser/front/js/utils/resolvable.js'
import * as menu from '../lightboxes/menus/menu.js'
import * as utilities from '../styles.js'
import * as sharedClasses from '#utilities/js/ea/sharedClasses.js'

const resolvers = new WeakMap()

const onClick = object(listener, {
  type: click,
  once,
  passive,
  task: button => {
    const { value } = button

    remove(button.closest(`div.${utilities.elements.modal}`))
    resolvers.get(button)?.(value === '1')
  }
})

const confirm = async (
  title,
  text = '',
  openers = []
) => {
  const { root } = defaults
  const template = one(`.${utilities.elements.aside_confirms} template`, root)
  const { content, parentNode } = template
  const [promise, { resolve }] = resolvable()

  const confirm = one(`div.${utilities.elements.modal}`, content).cloneNode(true)
  const dialog = one('dialog', confirm)
  const header = one(`div.${utilities.elements.modal_header}`, dialog)
  const h2 = one('h2', header)

  const main = one(`div.${utilities.elements.modal_main}`, dialog)
  const paragraph = one('p', main)

  const footer = one(`div.${utilities.elements.modal_footer}`, dialog)
  const buttons = all('button', footer)
  const [focusable] = buttons

  append(h2, title)

  if (text.length) {
    append(paragraph, text)
  }

  for (const button of buttons) {
    resolvers.set(button, resolve)
    onClick.listen(button)
  }

  await manager.fragment(confirm)
  replaceChildren(parentNode, template, confirm)
  sharedClasses.add(confirm, utilities.modifiers.overflow.hidden)
  focusable.focus()

  const result = await Promise.race([promise, await removed(confirm)])

  sharedClasses.remove(confirm, utilities.modifiers.overflow.hidden)

  for (const button of buttons) {
    resolvers.delete(button)
  }

  for (const opener of openers) {
    if (opener.ownerDocument?.contains(opener)) {
      opener.focus()
      break
    }
  }

  return result === true
}

export const fromOpener = async opener => {
  const { dataset } = opener
  const { confirm: message } = dataset

  if (!message) {
    return true
  }

  const { title, text = '' } = JSON.parse(message)
  const openers = [opener]
  const list = menu.list(opener)

  if (list) {
    openers.push(menu.opener(list))
  }

  const result = await confirm(title, text, openers)

  if (list) {
    menu.close()
  }

  return result
}

export default confirm
